module.exports = __webpack_public_path__ + "img/subject.8b909bb4.png";